import { ParameterType } from '@/study-search/enums';

import { AttendanceFilterOptionValue } from '@studyportals/search-filters';
import { IIndexation } from '../../../interfaces';
import { FilterKey } from '@studyportals/search-filters';
import { Filter } from '../Filter';

export class AttendanceFilter extends Filter implements IIndexation {
	public constructor() {
		super(FilterKey.DELIVERY_METHOD, ParameterType.DELIVERY_METHOD, []);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1 && this.values.includes(AttendanceFilterOptionValue.ONLINE);
	}
}
